import Clickable from 'components/Common/Clickable'
import FormatCurrency from 'components/Common/FormatCurrency'
import Image from 'components/Common/Image'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import Heading from 'components/Luxkit/Typography/Heading'
import useExperienceSearch from 'hooks/Experiences/useExperienceSearch'
import { getExperienceOfferPageURL } from 'lib/offerPageURL'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const PickItem = styled(Clickable)`
  display: grid;
  grid-template-columns: ${rem(100)} 1fr;
  height: ${rem(100)};
  gap: ${rem(16)};
  align-items: center;
  background-color: ${props => props.theme.palette.neutral.eight};
  transition: background-color 0.2s;
  border-radius: ${props => props.theme.borderRadius.medium};

  &:hover, &:focus {
    background-color: ${props => props.theme.palette.neutral.five};
  }

  .input-keyboard &:focus {
    outline: 2px solid  ${props => props.theme.palette.neutral.five};
    outline-offset: 2px;
  }
`

const ItemImage = styled(Image)`
  border-radius: ${props => props.theme.borderRadius.medium};
`

interface Props {
  place: App.Place;
}

function ExperiencesPageEditorsPickList(props: Props) {
  const { place } = props

  const [list, experiences] = useExperienceSearch({ placeId: place.id, sortBy: 'recommended', limit: 3 })

  return <VerticalSpacer gap={12}>
    {list.fetching && <>
      <LoadingBox style={{ height: rem(100), borderRadius: 4 }} />
      <LoadingBox style={{ height: rem(100), borderRadius: 4 }} />
      <LoadingBox style={{ height: rem(100), borderRadius: 4 }} />
    </>}
    {experiences.map(exp => <>
      {!exp && <LoadingBox style={{ height: rem(100), borderRadius: 4 }} />}
      {exp && <PickItem to={getExperienceOfferPageURL(exp)}>
        <ItemImage
          image={exp.images[0]}
          fit="center"
          height={100}
          width={100}
        />
        <VerticalSpacer gap={8}>
          <BodyText variant="medium" weight="bold" lineClamp={2}>{exp.name}</BodyText>
          <div>
            <Caption as="span" variant="large" colour="neutral-three">From</Caption>{' '}
            <Heading as="span" variant="heading6"><FormatCurrency value={exp.price} /></Heading>
            {exp.ticketUnitLabel && <Caption as="span" variant="large" colour="neutral-three">/{exp.ticketUnitLabel}</Caption>}
          </div>
        </VerticalSpacer>
      </PickItem>}
    </>)}
  </VerticalSpacer>
}

export default ExperiencesPageEditorsPickList
